import { Controller } from "@hotwired/stimulus"
import { GifExport } from "../modules/export_gif"

// Controls the GIF export panel for a single variant.
// Attach with: data-controller="export-gif" on the export card or container.
export default class extends Controller {
  connect() {
    this.instance = new GifExport()
    this.instance.init()
  }

  disconnect() {
    // Restore viewer settings if the helper is available
    if (typeof window.reset_viewer_settings === "function") {
      try {
        window.reset_viewer_settings()
      } catch (e) {
        console.warn("[export-gif] Failed to reset viewer settings", e)
      }
    }
  }
}

